import { render } from "./App.vue?vue&type=template&id=51b0ae5a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./App.vue?vue&type=style&index=1&id=51b0ae5a&lang=css"

import exportComponent from "/Users/lasse/Documents/DOFprojects/Danmarksfugle2.0-frontend/code-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__